module.exports = __webpack_public_path__ + "static/img/资源丰富@2x.9b0f97e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/资源丰富@2x.png
// module id = rKJX
// module chunks = 0